export default {
  userQueryIdCard: "/yangtse/certificate/registration/user/query/idcard",
  registrationDetail: "/yangtse/certificate/registration/detail",
  registrationCreate: "/yangtse/certificate/registration/create",
  registrationEdit: "/yangtse/certificate/registration/edit",
  filterJobLevel: "/yangtse/filter/job/level",
  certificateMajor: '/yangtse/certificate/registration/major',
  workJudge: '/yangtse/certificate/registration/certificate/judge',
};
